import { render, staticRenderFns } from "./IconRowItem.vue?vue&type=template&id=1766120e&scoped=true&"
import script from "./IconRowItem.vue?vue&type=script&lang=js&"
export * from "./IconRowItem.vue?vue&type=script&lang=js&"
import style0 from "./IconRowItem.vue?vue&type=style&index=0&id=1766120e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766120e",
  null
  
)

export default component.exports